//src/Components/SideBarNav/accountantMenu.tsx
import React from 'react';
import { commonMenu } from './commonMenu';
import NavItem from './NavItem';
import { ClientsIcon, PaymentsIcon } from 'assets/icons';

interface AccountantMenuProps {
  isTaxExpanded: boolean;
  setIsTaxExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  isFinCenExpanded: boolean;
  setIsFinCenExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  handleToggle: (
    setter: React.Dispatch<React.SetStateAction<boolean>>,
  ) => (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

export default function AccountantMenu(props: AccountantMenuProps) {
  return (
    <>
      {commonMenu({
        ...props,
        taxReturnsPath: '/dashboard/taxReturns',
        showServices: false,
      })}
      <NavItem
        icon={ClientsIcon}
        name="Clients"
        path="/dashboard/clients"
        className="custom-menu-item"
      />
      <NavItem
        icon={PaymentsIcon}
        name="Bundles"
        path="/dashboard/billing"
        className="custom-menu-item"
      />
    </>
  );
}
